import { render, staticRenderFns } from "./prop-binding-canvas.vue?vue&type=template&id=2f78d49c&scoped=true&"
import script from "./prop-binding-canvas.vue?vue&type=script&lang=ts&"
export * from "./prop-binding-canvas.vue?vue&type=script&lang=ts&"
import style0 from "./prop-binding-canvas.vue?vue&type=style&index=0&id=2f78d49c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f78d49c",
  null
  
)

export default component.exports